export const countUniquePageVisitsOnClientId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.page.view',
  key: 'countUniquePageVisitsOnClientId',
  targetProperty: 'actor.client.id',
}
